import { MultiTenantNetworkOrganizationEntity } from '../../normalization/graphql/normalizeMultiTenantOrganizationForHubNetwork.types';
import { MultiTenantOrganizationNetwork } from '../../state/multiTenantOrganizationNetworks/types';
import { EntityStatus, YammerState, getStatus } from '../../state/types';
import { createFindById } from '../findById';

export const findById = createFindById('multiTenantOrganizationNetworks');

type GetMultiTenantOrganizationConnectionsForHubNetwork = (
  state: YammerState
) => MultiTenantOrganizationNetwork[] | undefined;
export const getMultiTenantNetworks: GetMultiTenantOrganizationConnectionsForHubNetwork = (state) => {
  const fulfilledNetworks = state.multiTenantOrganizationNetworks.fulfilled.byId;

  return Object.values(fulfilledNetworks);
};

type GetMultiTenantOrganizationForHubNetworkStatus = (state: YammerState) => EntityStatus;
export const getMultiTenantOrganizationForHubNetworkStatus: GetMultiTenantOrganizationForHubNetworkStatus = (state) =>
  getStatus(state.multiTenantOrganizationForHubNetwork);

type GetMultiTenantOrganization = (state: YammerState) => MultiTenantNetworkOrganizationEntity | undefined;
export const getMultiTenantOrganization: GetMultiTenantOrganization = (state) =>
  state?.multiTenantOrganizationForHubNetwork?.fulfilled;
